import { toast } from 'react-toastify';
import { parseApiErrorMessage } from './errorUtils';

const parseMessage = (msg, defaultMsg = '') => {
    return parseApiErrorMessage(msg, defaultMsg);
};

export const showToast = {
    success: (message, options = {}) => {
        const text = parseMessage(message);
        const toastId = options.toastId || (text ? text : undefined);
        if (toastId && toast.isActive(toastId)) return;
        return toast.success(text, {
            toastId,
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            ...options,
        });
    },
    error: (message, options = {}) => {
        const text = parseMessage(message, 'Đã xảy ra lỗi!');
        const toastId = options.toastId || (text ? text : undefined);
        if (toastId && toast.isActive(toastId)) return;
        return toast.error(text, {
            toastId,
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            ...options,
        });
    },
    info: (message, options = {}) => {
        const text = parseMessage(message);
        const toastId = options.toastId || (text ? text : undefined);
        if (toastId && toast.isActive(toastId)) return;
        return toast.info(text, {
            toastId,
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            ...options,
        });
    },
    warning: (message, options = {}) => {
        const text = parseMessage(message);
        const toastId = options.toastId || (text ? text : undefined);
        if (toastId && toast.isActive(toastId)) return;
        return toast.warning(text, {
            toastId,
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            ...options,
        });
    },
};
